import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import { Field, reduxForm } from 'redux-form';

import PageHeader from '../../../shared/page-header/components/page-header';
import DefaultInput from '../../../shared/default-input/components/default-input';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import DefaultChecbox from '../../../shared/default-checkbox/components/default-checkbox';
import Button from '../../../shared/button/components/button';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import constants from '../../../../common/constants';
import paymentMethodsConstants from '../constants/payment-methods-constants';
import { validate } from '../validators/payment-methods-validators';
import { toggleAddPaymentMethodModal, saveUserPaymentMethod } from '../actions/payment-method-actions';

import '../styles/add-payment-methods-modal.css';

class AddPaymentMethodModal extends Component {
  closeModal() {
    const { toggleAddPaymentMethodModal } = this.props;

    toggleAddPaymentMethodModal(false);
  }

  getField(field) {
    const { httpInProgress, lang } = this.props;

    switch (field.type) {
      case constants.input_types.checkbox:
        return <Field name={field.id} value={false} label={field.label[lang]} disabled={httpInProgress} required={field.required} component={DefaultChecbox} />;
      case constants.input_types.select:
        return (
          <Field
            name={field.id}
            inputName={field.id}
            label={field.label[lang]}
            options={field.options}
            optionLabel={field.label}
            optionValue={field.value}
            disabled={httpInProgress}
            required={field.required}
            component={DefaultSelect}
          />
        );
      default:
        return <Field name={field.id} inputName={field.id} label={field.label[lang]} type={field.type} disabled={httpInProgress} component={DefaultInput} required={field.required} />;
    }
  }

  renderFields(fields) {
    if (fields && fields.length > 0) {
      return fields.map((field, index) => {
        return (
          <div className="col-md-6 m-b-20" key={index}>
            {this.getField(field)}
          </div>
        );
      });
    } else return null;
  }

  handleFormSubmit(values) {
    const { selectedPaymentMethodType, saveUserPaymentMethod } = this.props;

    const data = {
      payment_method_type_id: selectedPaymentMethodType.payment_method_type_id,
      fields_data: values,
    };

    saveUserPaymentMethod(data);
  }

  render() {
    const { showAddPaymentMethodModal, selectedPaymentMethodType, lang, httpInProgress, handleSubmit } = this.props;
    const fields = selectedPaymentMethodType && selectedPaymentMethodType.fields_config;

    return (
      <Modal visible={showAddPaymentMethodModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal add-payment-method-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader
              title={'PAYMENT_METHODS.ADD_METHOD_MODAL'}
              translationObject={{
                title: selectedPaymentMethodType.payment_method_type_id === constants.payment_method_types.bank.id ? 'Bank Account' : selectedPaymentMethodType.name[lang],
              }}
            />
          </div>
          <form noValidate onSubmit={handleSubmit(values => this.handleFormSubmit(values))}>
            <div className="row text-center">
              {this.renderFields(fields)}
              <Button label={'PAYMENT_METHOD.ADD_METHOD_BTN'} customClass={'affiliate-btn-red submit-btn m-t-20'} disabled={httpInProgress} type={'submit'} />
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showAddPaymentMethodModal: state.paymentMethodsReducer.showAddPaymentMethodModal,
  selectedPaymentMethodType: state.paymentMethodsReducer.selectedPaymentMethodType,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  lang: state.i18nState.lang,
});

const mapDispatchToProps = dispatch => ({
  toggleAddPaymentMethodModal: show => {
    dispatch(toggleAddPaymentMethodModal(show));
  },
  saveUserPaymentMethod: data => {
    dispatch(saveUserPaymentMethod(data));
  },
});

AddPaymentMethodModal = reduxForm({
  form: paymentMethodsConstants.form_name,
  validate,
})(AddPaymentMethodModal);

AddPaymentMethodModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentMethodModal);



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/components/add-payment-method-modal.js